"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREVIEW_TRANSITION_DURATION = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var theme_1 = require("../../utils/theme");
var helper_1 = require("../../utils/helper");
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
var phy_touch_1 = tslib_1.__importDefault(require("phy-touch"));
var alloyfinger_1 = tslib_1.__importDefault(require("alloyfinger"));
var css3transform_1 = tslib_1.__importDefault(require("css3transform"));
var Loading_1 = tslib_1.__importDefault(require("../Loading"));
var keepDom_1 = require("../../utils/keepDom");
var ActionSheet_1 = require("../ActionSheet");
var utils_1 = require("./utils");
exports.PREVIEW_TRANSITION_DURATION = 300;
var nextFrame = function () {
    var currentTime = Date.now();
    return new Promise(function (resolve) { return requestAnimationFrame(function () {
        var frameTime = Date.now();
        resolve(frameTime - currentTime);
    }); });
};
var Preview = (function (_super) {
    tslib_1.__extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerRef = React.createRef();
        _this.maskRef = React.createRef();
        _this.safeAreaRef = React.createRef();
        _this.wrapperRef = React.createRef();
        _this.pageRef = React.createRef();
        _this.imageWrapperRef = React.createRef();
        _this.imageRef = React.createRef();
        _this.state = {
            currentIndex: _this.props.initialIndex,
            imageStates: {},
            screenWidth: window.innerWidth,
            isWidgetsVisible: true,
            isActionSheetVisible: false,
            isSlideOutClose: false,
        };
        _this.isMultipointTouching = false;
        _this.multipointStartScale = 1;
        _this.currentImageScale = 1;
        _this.longTouchTime = 350;
        _this.setImageState = function (imageUrl, newState) {
            var _a = _this.state, imageStates = _a.imageStates, currentIndex = _a.currentIndex;
            var urlList = _this.props.urlList;
            imageStates[imageUrl] = imageUrl ? newState : 'error';
            _this.setState({ imageStates: imageStates });
            if (newState === 'loaded' || imageUrl === urlList[currentIndex]) {
                _this.scaleOnce(1);
            }
        };
        _this.handleHorizontalScrollEnd = function () {
            var page = _this.pageRef.current;
            if (!page)
                return;
            var threshold = window.innerWidth * 0.15;
            if (_this.valueX > _this.maxPageX) {
                if (!_this.isMultipointTouching && _this.valueX > _this.maxPageX + threshold) {
                    _this.prevPage();
                }
                else {
                    _this.toCurrentPageLeft();
                }
            }
            else if (_this.valueX < _this.minPageX) {
                if (!_this.isMultipointTouching && _this.valueX < _this.minPageX - threshold) {
                    _this.nextPage();
                }
                else {
                    _this.toCurrentPageRight();
                }
            }
        };
        _this.handleVerticalTouchMove = function () {
            if (_this.isMultipointTouching)
                return;
            var safeArea = _this.safeAreaRef.current;
            var mask = _this.maskRef.current;
            if (!safeArea || !mask)
                return;
            var verticalTouch = _this.verticalTouch;
            var _a = _this.props, allowSwipeDownToClose = _a.allowSwipeDownToClose, allowSwipeUpToClose = _a.allowSwipeUpToClose;
            var distance = (verticalTouch.preY - verticalTouch.start) / safeArea.clientHeight / 3;
            if (allowSwipeDownToClose && verticalTouch.isAtMax() ||
                allowSwipeUpToClose && verticalTouch.isAtMin()) {
                distance = Math.abs(distance);
                verticalTouch.startTime = Date.now();
            }
            else {
                distance = 0;
            }
            mask.style.opacity = 1 - distance;
        };
        _this.handleVerticalTouchEnd = function () {
            var safeArea = _this.safeAreaRef.current;
            var mask = _this.maskRef.current;
            if (!safeArea || !mask)
                return;
            var verticalTouch = _this.verticalTouch;
            var _a = _this.props, allowSwipeDownToClose = _a.allowSwipeDownToClose, allowSwipeUpToClose = _a.allowSwipeUpToClose;
            var threshold = safeArea.clientHeight * 0.2;
            var imageWrapper = _this.imageWrapperRef.current;
            if (!_this.isMultipointTouching && imageWrapper && (allowSwipeDownToClose && verticalTouch.isAtMax() && imageWrapper.translateY > _this.maxY + threshold ||
                allowSwipeUpToClose && verticalTouch.isAtMin() && imageWrapper.translateY < _this.minY - threshold)) {
                _this.requestClose(true);
            }
            mask.style.opacity = 1;
        };
        _this.handleTouchStart = function (e) {
            _this.isMultipointTouching = false;
            _this.touchStartEvent = e;
            _this.lastPositionalTouchEvent = e;
            if (_this.shouldShowActionSheet()) {
                _this.longTouchTimeout = setTimeout(function () {
                    if (!_this.isMultipointTouching) {
                        _this.props.onLongTapImage(_this.state.currentIndex);
                        if (window.navigator.vibrate) {
                            window.navigator.vibrate(50);
                        }
                        if (_this.props.visible) {
                            _this.setState({ isActionSheetVisible: true });
                        }
                    }
                }, _this.longTouchTime);
            }
        };
        _this.handleTouchMove = function (e) {
            if (_this.longTouchTimeout) {
                if (Math.abs(_this.touchStartEvent.touches[0].screenX - _this.lastPositionalTouchEvent.touches[0].screenX) > 20 ||
                    Math.abs(_this.touchStartEvent.touches[0].screenY - _this.lastPositionalTouchEvent.touches[0].screenY) > 20) {
                    clearTimeout(_this.longTouchTimeout);
                    _this.longTouchTimeout = null;
                    _this.setState({ isActionSheetVisible: false });
                }
            }
            _this.lastPositionalTouchEvent = e;
        };
        _this.handleTouchEnd = function (e) {
            if (_this.longTouchTimeout) {
                clearTimeout(_this.longTouchTimeout);
                _this.longTouchTimeout = null;
            }
            if (e.timeStamp - _this.touchStartEvent.timeStamp < 100 &&
                Math.abs(_this.touchStartEvent.touches[0].screenX - _this.lastPositionalTouchEvent.touches[0].screenX) < 20 &&
                Math.abs(_this.touchStartEvent.touches[0].screenY - _this.lastPositionalTouchEvent.touches[0].screenY) < 20) {
                if (_this.singleDoubleTapTimeout) {
                    if (Math.abs(_this.lastPositionalTouchEvent.touches[0].screenX - _this.firstTapPointX) < 20 &&
                        Math.abs(_this.lastPositionalTouchEvent.touches[0].screenY - _this.firstTapPointY) < 20) {
                        clearTimeout(_this.singleDoubleTapTimeout);
                        _this.singleDoubleTapTimeout = null;
                        var scale = _this.currentImageScale;
                        if (scale >= _this.props.scaleOnDoubleTap || scale < 1) {
                            _this.scaleTo(1, 200, _this.lastPositionalTouchEvent);
                        }
                        else {
                            _this.scaleTo(_this.props.scaleOnDoubleTap, 200, _this.lastPositionalTouchEvent);
                        }
                    }
                }
                else {
                    _this.firstTapPointX = _this.lastPositionalTouchEvent.touches[0].screenX;
                    _this.firstTapPointY = _this.lastPositionalTouchEvent.touches[0].screenY;
                    _this.singleDoubleTapTimeout = setTimeout(function () {
                        _this.props.onTapImage(_this.state.currentIndex);
                        if (_this.props.allowTapToClose && !_this.isMultipointTouching) {
                            _this.requestClose();
                        }
                        _this.singleDoubleTapTimeout = null;
                    }, 350);
                }
            }
        };
        _this.handleMultipointTouchStart = function () {
            _this.isMultipointTouching = true;
            _this.horizontalTouch.isTouchStart = false;
            _this.handleHorizontalScrollEnd();
            _this.verticalTouch.isTouchStart = false;
            _this.handleVerticalTouchEnd();
            _this.multipointStartScale = _this.currentImageScale;
        };
        _this.handleMultipointPinch = function (e) {
            if (_this.state.imageStates[_this.props.urlList[_this.state.currentIndex]] !== 'loaded')
                return;
            var newImageScale = e.zoom * _this.multipointStartScale;
            _this.scaleTo(newImageScale, 0, e);
        };
        _this.handleResize = function () {
            _this.setState({
                screenWidth: window.innerWidth
            }, function () {
                _this.toCurrentPageLeft(0);
                _this.scaleTo(1);
            });
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, visible = _a.visible, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, urlList = _a.urlList, maskStyle = _a.maskStyle, showPageNumber = _a.showPageNumber, renderWidgets = _a.renderWidgets;
            var _b = _this.state, currentIndex = _b.currentIndex, imageStates = _b.imageStates, screenWidth = _b.screenWidth, isWidgetsVisible = _b.isWidgetsVisible, isActionSheetVisible = _b.isActionSheetVisible, isSlideOutClose = _b.isSlideOutClose;
            if (!keepDom_1.decideKeepDom.call(_this, exports.PREVIEW_TRANSITION_DURATION, visible)) {
                return null;
            }
            var containerClasses = classNames("" + prefixCls, className, prefixCls + "-" + (visible ? 'visible' : 'hidden'), isSlideOutClose ? prefixCls + "-slide-out" : '');
            var maskClass = classNames(prefixCls + "-mask");
            var safeAreaClass = classNames(prefixCls + "-safe-area");
            var wrapperClass = classNames(prefixCls + "-wrapper");
            var pageClass = classNames(prefixCls + "-page");
            var imageLoadingClass = classNames(prefixCls + "-image-loading");
            var imageErrorClass = classNames(prefixCls + "-image-error");
            var imageContainerClass = classNames(prefixCls + "-image-container");
            var imageWrapperClass = classNames(prefixCls + "-image-wrapper");
            var imageClass = classNames(prefixCls + "-image");
            var pageNumberClasses = classNames(prefixCls + "-page-number", prefixCls + "-page-number-" + (isWidgetsVisible ? 'visible' : 'hidden'));
            var widgetsContainerClasses = classNames(prefixCls + "-widgets-container", prefixCls + "-widgets-container-" + (isWidgetsVisible ? 'visible' : 'hidden'));
            var actionSheetConfig = _this.getActionSheetConfig();
            return react_dom_1.default.createPortal(h("div", { className: containerClasses, ref: _this.containerRef, style: style, onMouseDownCapture: function () { return _this.requestClose(); } },
                h("div", { className: maskClass, ref: _this.maskRef, style: maskStyle }),
                h("div", { className: safeAreaClass, ref: _this.safeAreaRef },
                    h("div", { className: wrapperClass, ref: _this.wrapperRef }, urlList.map(function (imageUrl, i) { return (h("div", { className: pageClass + " " + (i === currentIndex ? pageClass + "-current" : ''), ref: i === currentIndex ? _this.pageRef : null, key: i, style: {
                            minWidth: screenWidth + 'px',
                            maxWidth: i === currentIndex ? 'none' : screenWidth + 'px'
                        } },
                        h("div", { className: imageContainerClass },
                            h("div", { className: imageWrapperClass, ref: i === currentIndex ? _this.imageWrapperRef : null, key: imageUrl },
                                Math.abs(i - currentIndex) <= 1 && h("img", { className: imageClass, style: { visibility: imageStates[imageUrl] === 'loaded' ? 'visible' : 'hidden' }, src: imageUrl, key: imageUrl, ref: i === currentIndex ? _this.imageRef : null, onLoad: function () { return _this.setImageState(imageUrl, 'loaded'); }, onError: function () { return _this.setImageState(imageUrl, 'error'); } }),
                                !imageStates[imageUrl] && h(Loading_1.default, { className: imageLoadingClass, spinType: "light" }),
                                imageStates[imageUrl] === 'error' && h("div", { className: imageErrorClass }, "\u52A0\u8F7D\u5931\u8D25"))))); })),
                    showPageNumber && urlList.length > 1 && h("div", { className: pageNumberClasses },
                        currentIndex + 1,
                        "/",
                        urlList.length),
                    h("div", { className: widgetsContainerClasses }, !_this.shouldShowActionSheet() ? renderWidgets(currentIndex) : ''),
                    actionSheetConfig && actionSheetConfig.length > 0 && h(ActionSheet_1.ActionSheet, { visible: isActionSheetVisible, onClickAction: function (id) {
                            var targetConfig = actionSheetConfig.find(function (config) { return config.id === id; });
                            if (targetConfig) {
                                targetConfig.onClick && targetConfig.onClick(currentIndex);
                                _this.setState({ isActionSheetVisible: false });
                            }
                        }, onCancel: function () {
                            _this.setState({
                                isActionSheetVisible: false,
                            });
                        }, options: actionSheetConfig.map(function (config) {
                            return {
                                id: config.id,
                                disabled: config.disabled || false,
                            };
                        }) }))), document.body);
        };
        return _this;
    }
    Preview.prototype.componentDidMount = function () {
        this.blockEventDefaults();
        this.initHorizontalTouch();
        this.initVerticalTouch();
        this.initMultipointTouch();
        this.initForCurrentImage();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
        this.handleResize();
    };
    Preview.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.currentIndex !== this.state.currentIndex) {
            this.toCurrentPageLeft();
            this.initForCurrentImage();
            this.scaleOnce(1);
            this.currentImageScale = 1;
            this.props.onChange(this.state.currentIndex);
        }
        if (prevProps.initialIndex !== this.props.initialIndex) {
            this.updateCurrentPage(this.props.initialIndex);
        }
        else if (prevProps.urlList !== this.props.urlList) {
            this.updateCurrentPage();
        }
        if (prevProps.visible && !this.props.visible) {
            this.onClose();
        }
    };
    Preview.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleResize);
        clearTimeout(this.singleDoubleTapTimeout);
    };
    Preview.prototype.blockEventDefaults = function () {
        var wrapper = this.wrapperRef.current;
        wrapper.addEventListener('dragstart', function (e) { return e.preventDefault(); });
        wrapper.addEventListener('dragover', function (e) { return e.preventDefault(); });
        wrapper.addEventListener('touchmove', function (e) { return e.preventDefault(); });
        wrapper.addEventListener('touchend', function (e) { return e.preventDefault(); });
        wrapper.addEventListener('click', function (e) { return e.preventDefault(); });
        if (this.shouldShowActionSheet()) {
            wrapper.addEventListener('touchstart', function (e) { return e.preventDefault(); });
        }
    };
    Preview.prototype.updateCurrentPage = function (pageIndex, animated) {
        if (pageIndex === void 0) { pageIndex = this.state.currentIndex; }
        if (animated === void 0) { animated = true; }
        var urlList = this.props.urlList;
        if (!urlList.length) {
            this.requestClose();
        }
        var index = Math.max(0, Math.min(pageIndex, urlList.length - 1));
        this.setState({
            currentIndex: index
        });
        this.toCurrentPageLeft(animated ? 200 : 0);
    };
    Preview.prototype.initHorizontalTouch = function () {
        var _this = this;
        var wrapper = this.wrapperRef.current;
        css3transform_1.default(wrapper);
        this.horizontalTouch = new phy_touch_1.default({
            touch: wrapper,
            target: this,
            property: 'valueX',
            min: 0,
            max: 0,
            deceleration: 0.01,
            vertical: false,
            lockDirection: false,
            touchEnd: this.handleHorizontalScrollEnd,
            animationEnd: this.handleHorizontalScrollEnd,
        });
        Object.defineProperty(this.horizontalTouch, 'min', { get: function () { return _this.minX; } });
        Object.defineProperty(this.horizontalTouch, 'max', { get: function () { return _this.maxX; } });
        Object.defineProperty(this.horizontalTouch, 'lockDirection', { get: function () { return _this.lockDirectionX; } });
        this.updateCurrentPage();
    };
    Object.defineProperty(Preview.prototype, "valueX", {
        get: function () {
            var wrapper = this.wrapperRef.current;
            if (!wrapper)
                return 0;
            return wrapper.translateX;
        },
        set: function (value) {
            var wrapper = this.wrapperRef.current;
            if (!wrapper)
                return;
            wrapper.translateX = value;
            this.updateWidgetsVisibility();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "minX", {
        get: function () {
            var page = this.pageRef.current;
            var safeArea = this.safeAreaRef.current;
            if (!page || !safeArea)
                return 0;
            return -((this.props.urlList.length - 2) * safeArea.clientWidth + page.clientWidth);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "maxX", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "minPageX", {
        get: function () {
            var page = this.pageRef.current;
            var safeArea = this.safeAreaRef.current;
            if (!page || !safeArea)
                return 0;
            return (1 - this.state.currentIndex) * safeArea.clientWidth - page.clientWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "maxPageX", {
        get: function () {
            var safeArea = this.safeAreaRef.current;
            if (!safeArea)
                return 0;
            return -this.state.currentIndex * safeArea.clientWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "lockDirectionX", {
        get: function () {
            return this.currentImageScale <= 1;
        },
        enumerable: false,
        configurable: true
    });
    Preview.prototype.initVerticalTouch = function () {
        var _this = this;
        var wrapper = this.wrapperRef.current;
        var imageWrapper = this.imageWrapperRef.current;
        css3transform_1.default(imageWrapper);
        this.verticalTouch = new phy_touch_1.default({
            touch: wrapper,
            target: this,
            property: 'valueY',
            min: 0,
            max: 0,
            deceleration: 0.01,
            outFactor: 0.6,
            touchMove: this.handleVerticalTouchMove,
            touchEnd: this.handleVerticalTouchEnd,
        });
        Object.defineProperty(this.verticalTouch, 'min', { get: function () { return _this.minY; } });
        Object.defineProperty(this.verticalTouch, 'max', { get: function () { return _this.maxY; } });
    };
    Object.defineProperty(Preview.prototype, "valueY", {
        get: function () {
            var imageWrapper = this.imageWrapperRef.current;
            if (!imageWrapper)
                return 0;
            return imageWrapper.translateY;
        },
        set: function (value) {
            var imageWrapper = this.imageWrapperRef.current;
            if (!imageWrapper)
                return;
            imageWrapper.translateY = value;
            this.updateWidgetsVisibility();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "minY", {
        get: function () {
            var safeArea = this.safeAreaRef.current;
            var imageWrapper = this.imageWrapperRef.current;
            if (!safeArea || !imageWrapper)
                return 0;
            return -Math.max(0, imageWrapper.clientHeight - safeArea.clientHeight);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "maxY", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Preview.prototype, "maxControlWidgetHeight", {
        get: function () {
            return window.innerHeight - 24;
        },
        enumerable: false,
        configurable: true
    });
    Preview.prototype.initMultipointTouch = function () {
        var wrapper = this.wrapperRef.current;
        this.multipointTouch = new alloyfinger_1.default(wrapper, {
            touchStart: this.handleTouchStart,
            touchMove: this.handleTouchMove,
            touchEnd: this.handleTouchEnd,
            multipointStart: this.handleMultipointTouchStart,
            pinch: this.handleMultipointPinch,
        });
        this.scaleOnce(1);
    };
    Preview.prototype.initForCurrentImage = function () {
        var imageWrapper = this.imageWrapperRef.current;
        css3transform_1.default(imageWrapper);
    };
    Preview.prototype.toCurrentPageLeft = function (duration) {
        var _this = this;
        if (duration === void 0) { duration = 200; }
        setTimeout(function () {
            _this.horizontalTouch.stop();
            _this.horizontalTouch.to(_this.maxPageX, duration);
        }, 0);
    };
    Preview.prototype.toCurrentPageRight = function (duration) {
        var _this = this;
        if (duration === void 0) { duration = 200; }
        setTimeout(function () {
            _this.horizontalTouch.stop();
            _this.horizontalTouch.to(_this.minPageX, duration);
        }, 0);
    };
    Preview.prototype.scaleTo = function (scale, duration, event) {
        if (duration === void 0) { duration = 200; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var safeArea, imageWrapper, wrapper, oldScale, oldX, oldY, requestedScale, centerPointScreenX, centerPointScreenY, touches, imageTranslateX, imageTranslateY, centerPointImageX, centerPointImageY, newImageTranslateX, newImageTranslateY, deltaScale, deltaX, deltaY, time, frame, progress;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        safeArea = this.safeAreaRef.current;
                        imageWrapper = this.imageWrapperRef.current;
                        wrapper = this.wrapperRef.current;
                        if (!safeArea || !imageWrapper || !wrapper)
                            return [2];
                        oldScale = this.currentImageScale;
                        oldX = wrapper.translateX - this.maxPageX;
                        oldY = imageWrapper.translateY;
                        requestedScale = Math.min(scale, this.props.maxScale);
                        centerPointScreenX = safeArea.clientWidth / 2;
                        centerPointScreenY = safeArea.clientHeight / 2;
                        if (event && event.touches.length) {
                            touches = Array.from(event.touches);
                            centerPointScreenX = touches
                                .map(function (touch) { return touch.pageX - window.scrollX; })
                                .reduce(function (a, b) { return a + b; }, 0) / touches.length;
                            centerPointScreenY = touches
                                .map(function (touch) { return touch.pageY - window.scrollY; })
                                .reduce(function (a, b) { return a + b; }, 0) / touches.length;
                        }
                        imageTranslateX = wrapper.translateX - this.maxPageX;
                        imageTranslateY = imageWrapper.translateY;
                        centerPointImageX = (centerPointScreenX - imageTranslateX) / oldScale;
                        centerPointImageY = (centerPointScreenY - imageTranslateY) / oldScale;
                        newImageTranslateX = centerPointScreenX - centerPointImageX * requestedScale;
                        newImageTranslateY = centerPointScreenY - centerPointImageY * requestedScale;
                        deltaScale = requestedScale - oldScale;
                        deltaX = newImageTranslateX - oldX;
                        deltaY = newImageTranslateY - oldY;
                        time = 0;
                        frame = 0;
                        _a.label = 1;
                    case 1:
                        if (!(time < duration)) return [3, 3];
                        progress = time / duration;
                        this.scaleOnce(oldScale + deltaScale * progress);
                        this.moveOnce(oldX + deltaX * progress, oldY + deltaY * progress);
                        time += frame;
                        return [4, nextFrame()];
                    case 2:
                        frame = _a.sent();
                        return [3, 1];
                    case 3:
                        this.currentImageScale = this.scaleOnce(requestedScale);
                        this.moveOnce(newImageTranslateX, newImageTranslateY);
                        return [2];
                }
            });
        });
    };
    Preview.prototype.moveTo = function (x, y, duration) {
        if (duration === void 0) { duration = 200; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var wrapper, imageWrapper, oldX, oldY, deltaX, deltaY, time, frame, progress;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        wrapper = this.wrapperRef.current;
                        imageWrapper = this.imageWrapperRef.current;
                        if (!imageWrapper || !wrapper)
                            return [2];
                        oldX = wrapper.translateX - this.maxPageX;
                        oldY = imageWrapper.translateY;
                        deltaX = x - oldX;
                        deltaY = y - oldY;
                        if (!(oldX !== x || oldY !== y)) return [3, 4];
                        time = 0;
                        frame = 0;
                        _a.label = 1;
                    case 1:
                        if (!(time < duration)) return [3, 3];
                        progress = time / duration;
                        this.moveOnce(oldX + deltaX * progress, oldY + deltaY * progress);
                        time += frame;
                        return [4, nextFrame()];
                    case 2:
                        frame = _a.sent();
                        return [3, 1];
                    case 3:
                        this.moveOnce(x, y);
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    Preview.prototype.scaleOnce = function (scale) {
        var safeArea = this.safeAreaRef.current;
        var imageWrapper = this.imageWrapperRef.current;
        var image = this.imageRef.current;
        if (!safeArea || !imageWrapper || !image)
            return 0;
        if (!image.naturalWidth)
            return scale;
        var initialImageWidth = Math.min(image.naturalWidth, safeArea.clientWidth);
        var initialImageHeight = image.naturalHeight / image.naturalWidth * initialImageWidth;
        var requestedWidth = initialImageWidth * scale;
        var requestedHeight = initialImageHeight * scale;
        var newScale = scale;
        var minFitWidth = Math.min(safeArea.clientWidth, image.naturalWidth);
        var minFitHeight = Math.min(safeArea.clientHeight, image.naturalHeight);
        var maxScale = this.props.maxScale;
        if (requestedWidth < minFitWidth && requestedHeight < minFitHeight) {
            newScale *= Math.min(minFitWidth / requestedWidth, minFitHeight / requestedHeight);
        }
        else if (scale > maxScale) {
            newScale = maxScale;
        }
        imageWrapper.style.width = initialImageWidth * newScale + 'px';
        imageWrapper.style.height = initialImageHeight * newScale + 'px';
        return newScale;
    };
    Preview.prototype.moveOnce = function (x, y) {
        var safeArea = this.safeAreaRef.current;
        var imageWrapper = this.imageWrapperRef.current;
        if (!safeArea || !imageWrapper)
            return;
        var imageWidth = imageWrapper.clientWidth;
        var imageHeight = imageWrapper.clientHeight;
        var screenWidth = safeArea.clientWidth;
        var screenHeight = safeArea.clientHeight;
        var newMoveX = x;
        var newMoveY = y;
        if (imageWidth < screenWidth) {
            newMoveX = 0;
        }
        else {
            newMoveX = Math.max(Math.min(0, newMoveX), screenWidth - imageWidth);
        }
        if (imageHeight < screenHeight) {
            newMoveY = 0;
        }
        else {
            newMoveY = Math.min(Math.max(this.minY, newMoveY), this.maxY);
        }
        this.valueX = -this.state.currentIndex * safeArea.clientWidth + newMoveX;
        this.valueY = newMoveY;
        return [newMoveX, newMoveY];
    };
    Preview.prototype.prevPage = function () {
        this.scaleOnce(1);
        this.valueY = 0;
        this.setState({
            currentIndex: Math.max(0, this.state.currentIndex - 1)
        });
    };
    Preview.prototype.nextPage = function () {
        var overScroll = this.valueX - this.minPageX;
        this.scaleOnce(1);
        this.valueX = this.minPageX + overScroll;
        this.valueY = 0;
        this.setState({
            currentIndex: Math.min(this.props.urlList.length - 1, this.state.currentIndex + 1)
        });
    };
    Preview.prototype.requestClose = function (isSlideOutClose) {
        if (isSlideOutClose === void 0) { isSlideOutClose = false; }
        if (this.state.isActionSheetVisible) {
            return;
        }
        this.setState({ isSlideOutClose: isSlideOutClose });
        this.props.onClose();
    };
    Preview.prototype.onClose = function () {
        var _this = this;
        setTimeout(function () {
            _this.horizontalTouch.stop();
            _this.verticalTouch.stop();
        }, 0);
    };
    Preview.prototype.updateWidgetsVisibility = function () {
        var isWidgetsVisible = this.valueY === 0 && this.currentImageScale <= 1;
        if (this.props.visible && this.state.isWidgetsVisible !== isWidgetsVisible) {
            this.setState({
                isWidgetsVisible: this.valueY === 0 && this.currentImageScale <= 1
            });
        }
    };
    Preview.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Preview.prototype.shouldShowActionSheet = function () {
        var actionSheetConfig = this.props.actionSheetConfig;
        if (!actionSheetConfig) {
            return false;
        }
        return true;
    };
    Preview.prototype.getActionSheetConfig = function () {
        var _a = this.props, urlList = _a.urlList, actionSheetConfig = _a.actionSheetConfig;
        if ((actionSheetConfig && actionSheetConfig.length === 0)) {
            return utils_1.getDefaultActionSheet(urlList);
        }
        return actionSheetConfig;
    };
    return Preview;
}(React.Component));
exports.default = Preview;
Preview.defaultProps = {
    visible: true,
    prefixCls: 'dui-m-preview',
    initialIndex: 0,
    maskStyle: {},
    showPageNumber: true,
    renderWidgets: function () { return null; },
    allowSwipeDownToClose: true,
    allowSwipeUpToClose: false,
    allowTapToClose: true,
    maxScale: 5,
    scaleOnDoubleTap: 2,
    onChange: helper_1.emptyFn,
    onTapImage: helper_1.emptyFn,
    onClose: helper_1.emptyFn,
    onLongTapImage: helper_1.emptyFn,
    actionSheetConfig: docs_user_agent_1.default.isQQ || docs_user_agent_1.default.isWeChat || docs_user_agent_1.default.isWxWork || docs_user_agent_1.default.isTim || docs_user_agent_1.default.isMiniProgram ? null : [],
};
Preview.propTypes = {
    visible: PropTypes.bool,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    urlList: PropTypes.arrayOf(PropTypes.string),
    initialIndex: PropTypes.number,
    maskStyle: PropTypes.object,
    showPageNumber: PropTypes.bool,
    renderWidgets: PropTypes.func,
    allowSwipeDownToClose: PropTypes.bool,
    allowSwipeUpToClose: PropTypes.bool,
    allowTapToClose: PropTypes.bool,
    maxScale: PropTypes.number,
    scaleOnDoubleTap: PropTypes.number,
    onChange: PropTypes.func,
    onTapImage: PropTypes.func,
    onClose: PropTypes.func,
    onLongTapImage: PropTypes.func,
    actionSheetConfig: PropTypes.array,
};
